import React, { useEffect, useState } from "react";
import { Col, Row, Select, Typography } from "antd";

import { Input, Button, Space } from "antd";
import { toast } from "react-toastify";
import CustomCard from "./CustomCard";
const { Paragraph } = Typography;
const { Option } = Select;

export default function Keywords({
	keywords,
	setKeywords,
	loading,
	showAIInputs,
	setShowAIInputs,
	numberOfKeywords,
	setNumberOfKeywords,
	keywordCountry,
	setKeywordCountry,
	keywordTopic,
	setKeywordTopic,
	isButtonLoading,
	handleGenerateKeywords,
}) {
	return (
		<CustomCard>
			<Paragraph>Keywords (comma-separated):</Paragraph>
			<Space direction="vertical" style={{ width: "100%" }}>
				<Input
					value={keywords}
					onChange={(e) => setKeywords(e.target.value)}
					placeholder="Enter keywords, separated by commas"
					disabled={loading}
				/>
				<Button type="dashed" onClick={() => setShowAIInputs(!showAIInputs)}>
					{showAIInputs ? "Cancel AI Generation" : "Generate with AI"}
				</Button>
			</Space>
			{showAIInputs && (
				<KeywordsGenerateSection
					numberOfKeywords={numberOfKeywords}
					setNumberOfKeywords={setNumberOfKeywords}
					keywordCountry={keywordCountry}
					setKeywordCountry={setKeywordCountry}
					keywordTopic={keywordTopic}
					setKeywordTopic={setKeywordTopic}
					isButtonLoading={isButtonLoading}
					handleGenerateKeywords={handleGenerateKeywords}
				/>
			)}
		</CustomCard>
	);
}

export const KeywordsGenerateSection = ({
	numberOfKeywords,
	setNumberOfKeywords,
	keywordCountry,
	setKeywordCountry,
	keywordTopic,
	setKeywordTopic,
	isButtonLoading,
	handleGenerateKeywords,
}) => {
	const handleSubmit = () => {
		console.log("cskdchd");
		// Validate inputs
		if (!numberOfKeywords || numberOfKeywords < 1 || numberOfKeywords > 10) {
			toast.error("Please enter a valid number of keywords (1-10).");
			return;
		}

		if (!keywordCountry) {
			toast.error("Please enter a country.");
			return;
		}

		if (!keywordTopic) {
			toast.error("Please enter a topic.");
			return;
		}

		// If all inputs are valid, call the generate function
		handleGenerateKeywords();
	};
	const [countries, setCountries] = useState([]);

	useEffect(() => {
		const fetchCountries = async () => {
			try {
				const response = await fetch("https://restcountries.com/v3.1/all");
				const data = await response.json();
				const countryList = data.map((country) => ({
					name: country.name.common,
					code: country.cca2,
					flag: country.flags?.svg,
				}));
				console.log(countryList, "chgchgchgcghfc");
				setCountries(countryList);
			} catch (error) {
				console.error("Error fetching countries:", error);
			}
		};

		fetchCountries();
	}, []);
	return (
		<Row gutter={16} align="middle" style={{ marginTop: 16 }}>
			{/* Number of Keywords */}
			<Col span={8}>
				<Input
					placeholder="Number of Keywords (1-10)"
					value={numberOfKeywords}
					onChange={(e) => setNumberOfKeywords(e.target.value)}
					type="number"
					min={1}
					max={10}
				/>
			</Col>

			{/* Keyword Country */}
			<Col span={8}>
				<Select
					placeholder="Select a country"
					value={keywordCountry}
					onChange={setKeywordCountry}
					showSearch={true}
					style={{
						width: "100%",
					}}
				>
					{countries.map(({ code, name, flag }) => (
						<Option key={code} value={code}>
							<img
								src={flag}
								alt={name}
								style={{ width: 20, height: 15, marginRight: 8 }}
							/>
							{name}
						</Option>
					))}
				</Select>
			</Col>

			{/* Keyword Topic */}
			<Col span={8}>
				<Input
					placeholder="Topic (e.g., Trading, Social Media)"
					value={keywordTopic}
					onChange={(e) => setKeywordTopic(e.target.value)}
				/>
			</Col>

			{/* Generate Button */}
			<Col span={24} style={{ marginTop: 16 }}>
				<Button
					type="primary"
					onClick={handleSubmit}
					loading={isButtonLoading}
					style={{ width: "100%" }}
				>
					Generate Keywords
				</Button>
			</Col>
		</Row>
	);
};
